import { render, staticRenderFns } from "./PublicSocialLoginLinkedIn.vue?vue&type=template&id=36b4de8d"
import script from "./PublicSocialLoginLinkedIn.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLoginLinkedIn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports